import { StyleSheet } from "aphrodite";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { accentColor } from "main/javascripts/styles/base/colorStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IStyle {
  block: any;
  title: any;
}

export const BlockSubTitleStyle: IStyle = StyleSheet.create({
  block: {
    padding: space.atom,
  },
  title: {
    fontSize: fontSize.subHeading,
    lineHeight: lineHeight.mediumHeadline1,
    color: accentColor.secondaryColor2,
    padding: space.atom,
    margin: "0.5rem 0",
    letterSpacing: "0.1em",
    [moreThanBreakpoint("tablet")]: {
      fontSize: fontSize.mediumHeading,
    },
  },
});
